module.exports = __webpack_public_path__ + "static/media/view complaint.8309e86e.svg";